import React from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import Stepper from '../../organisms/Stepper';
import { FormInput, FormTextarea } from '../../molecules/FormField';
import Button from '../../atoms/Button';
import ChevronRightIcon from '../../atoms/ChevronRightIcon';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import {
  DEMO_DEPARTMENTS_TREE,
  SETTINGS_STEPS,
  WORKFLOW_SUBSTEPS,
} from '../../../data/settingsSteps';

export default function WorkflowStep({
  onNext,
  stepMeta,
  substep = 1,
  onSubstepChange,
  stepperProps,
}) {
  const { state, update, updateWorkflow } = useSettingsWizard();
  const { selectedDeptNode, workflow } = state;

  const handleNextSubstep = () => {
    if (substep < WORKFLOW_SUBSTEPS.length) {
      onSubstepChange?.(substep + 1);
      return;
    }
    onNext?.();
  };

  return (
    <>
      <Stepper {...stepperProps} steps={SETTINGS_STEPS} />
      <SettingsCard
      title={stepMeta.title}
      description={stepMeta.description}
      showNext={false}
    >
      <div className="ca-workflow">
        <aside className="ca-workflow__sidebar">
          <h3 className="ca-workflow__sidebar-title">Select Department</h3>
          <p className="ca-small">Add workflow for selected department</p>
          <ul className="ca-dept-tree">
            {DEMO_DEPARTMENTS_TREE.map((dept) => (
              <li key={dept.id} className="ca-dept-tree__group">
                <button
                  type="button"
                  className={`ca-dept-tree__item ${
                    selectedDeptNode === dept.id ? 'ca-dept-tree__item--active' : ''
                  }`}
                  onClick={() => update({ selectedDeptNode: dept.id })}
                >
                  {dept.name}
                </button>
                {dept.children?.length ? (
                  <ul className="ca-dept-tree__children">
                    {dept.children.map((child) => (
                      <li key={child.id}>
                        <button
                          type="button"
                          className={`ca-dept-tree__item ca-dept-tree__item--child ${
                            selectedDeptNode === child.id
                              ? 'ca-dept-tree__item--active'
                              : ''
                          }`}
                          onClick={() => update({ selectedDeptNode: child.id })}
                        >
                          <span className="ca-dept-tree__branch" aria-hidden="true">
                            └
                          </span>
                          {child.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            ))}   
          </ul>
        </aside>

        <div className="ca-workflow__main">
          <Stepper
            steps={WORKFLOW_SUBSTEPS}
            currentStep={substep}
            onStepClick={onSubstepChange}
            size="sm"
            className="ca-workflow__substepper"
          />

          {substep === 1 ? (
            <div className="ca-workflow__form">
              <div className="ca-step-row">
                <FormInput
                  className="ca-step-row__grow"
                  label="Name"
                  placeholder="Enter name"
                  value={workflow.name}
                  onChange={(e) => updateWorkflow({ name: e.target.value })}
                />
                <FormInput
                  className="ca-step-row__grow"
                  label="TAT Minutes"
                  placeholder="Enter here"
                  value={workflow.tatMinutes}
                  onChange={(e) => updateWorkflow({ tatMinutes: e.target.value })}
                />
              </div>
              <FormTextarea
                label="Description"
                placeholder="Enter description"
                value={workflow.description}
                onChange={(e) => updateWorkflow({ description: e.target.value })}
                rows={5}
              />
            </div>
          ) : null}

          {substep === 2 ? (
            <div className="ca-workflow__placeholder">
              <p className="ca-body">
                Configure workflow statuses for the selected department.
              </p>
            </div>
          ) : null}

          {substep === 3 ? (
            <div className="ca-workflow__placeholder">
              <p className="ca-body">Define ordered workflow steps and assignees.</p>
            </div>
          ) : null}

          <div className="ca-workflow__actions">
            <Button
              onClick={handleNextSubstep}
              endIcon={<ChevronRightIcon size={14} color="#fff" />}
            >
              Next Step
            </Button>
          </div>
        </div>
      </div>
      </SettingsCard>
    </>
  );
}
